<template>
  <div id="header-component">
    <div class="header-root__container">
      <div class="header-root__container__item">
        <button
          id="main-describe"
          @click="onHeaderButClick"
          class="header_button"
        >
          О студии
        </button>
      </div>
      <div class="header-root__container__item">
        <button
          id="student-works"
          @click="onHeaderButClick"
          class="header_button"
        >
          Работы
        </button>
      </div>
      <div class="header-root__container__item logo">
      </div>
      <div class="header-root__container__item">
        <button
          id="master-class"
          @click="onHeaderButClick"
          class="header_button"
        >
          Услуги
        </button>
      </div>
      <div class="header-root__container__item" style="margin-right: unset">
        <button id="address" @click="onHeaderButClick" class="header_button">
          Контакты
        </button>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  data() {
    return {
      count: 1,
    };
  },
  methods: {
    onHeaderButClick(event: Event) {
      this.$emit("navClick", (event.target as HTMLInputElement).id);
    },
  },
});
</script>

<style scoped lang="less">
@import "../assets/styles/colors.less";

#header-component {
  position: fixed;
  top: 0;
  z-index: 2;

  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  background: @other_1;

  .header-root__container {
    display: flex;
    justify-content: space-between;
    align-items: center;

    color: @text_3;
    .header_button {
      all: unset;
      cursor: pointer;
      font-family: Monserrat, sans-serif;
      font-size: 20px;
      font-weight: 800;
      line-height: 24.38px;
    }

    @logo-max-width: 138px;
    @logo-msx-height: 134px;
    @button-max-margin: 80px;

    @media (max-width: 820px) {
      padding: 16px 30px 22px;

      .header_button {
        font-size: 0.55em;
      }
      .header-root__container__item {
        margin-right: calc(@button-max-margin / 4);
      }

      .logo {
          width: calc(@logo-max-width / 2);
          height: calc(@logo-msx-height / 2);
          background: url("@/assets/logo.png") no-repeat center;
          background-size: contain;

      }
    }

    @media (min-width: 820px) and (max-width: 1000px) {
      padding: 16px 10px 22px;

      .header_button {
        font-size: 0.9em;
      }
      .header-root__container__item {
        margin-right: calc(@button-max-margin / 2);
      }

      .logo {
          width: calc(@logo-max-width / 1.5);
          height: calc(@logo-msx-height / 1.5);
          background: url("@/assets/logo.png") no-repeat center;
          background-size: contain;

      }
    }

    @media (min-width: 1000px) {
      padding: 16px 2px 22px;
      font-size: 0.99em;
      .logo {
        width: @logo-max-width - 20px;
        height: @logo-msx-height - 20px;
        background: url("@/assets/logo.png") no-repeat center;
        background-size: contain;

      }
      .header-root__container__item {
        margin-right: 80px;
      }
    }
  }
}
</style>
